




































































































//import CategoriaDistanciaCarreraAdd from "./DistanciaCarreraAdd.vue";
import Vue from "vue";
/*
import DistanciaCarreraService, {
  DistanciaCarreraCreateDto
} from "@/api/carrera/detalle/DistanciaCarrera.service";
*/

//import DistanciaService, { DistanciaCreateDto } from "@/api/DistanciaService";
import PapeletaAprobar from "@/components/admin/transacciones/PapeletaAprobar.vue";
import RegistroCarreraService, {
  RegistroCarreraCreateDto
} from "@/api/carrera/detalle/RegistroCarreraService";
import XLSX from "xlsx";
import moment from "moment";
import { PedidoDto } from "@/api/pedido/PedidoService";

export default Vue.extend({
  components: {
    PapeletaAprobar
  },
  data() {
    return {
      search: "",
      dialog: false,
      headers: [
        { text: "#Rg", value: "id" },
        { text: "#Pd", value: "pedido.id" },
        { text: "Identificación", value: "persona.identificacion" },
        { text: "Nombre", value: "persona.nombre" },
        { text: "Apellido", value: "persona.apellido" },
        { text: "Distancia", value: "distancia.nombre" },
        { text: "Categoria", value: "categoria.nombre" },
        { text: "Talla", value: "tallaCamiseta.talla.nombre" },
        { text: "Modelo", value: "tallaCamiseta.modelo" },
        { text: "Personalización", value: "personalizacionCamiseta" },
        { text: "Acción", value: "actions", sortable: false }
      ],
      datos: [] as RegistroCarreraCreateDto[],
      totalRecaudado: "0.00",
      dato: {
        id: 0
      } as PedidoDto
    };
  },
  methods: {
    loadTotalRecaudado() {
      let total = 0;
      for (const doc of this.datos) {
        const p = doc as any;
        total += Number(p.total);
      }
      this.totalRecaudado = total.toFixed(2);
    },
    exportExcel() {
      const data = XLSX.utils.table_to_sheet(
        document.getElementById("tablita")
      );
      const workbook = XLSX.utils.book_new();
      const filename = "carrera-registros-pagados";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    setDefaultItem() {
      const newDto = {
        id: 0
      };
      this.dato = newDto;
    },
    editItem(item: PedidoDto) {
      this.dato = item;
      this.dialogChange(true);
    },
    newItem() {
      this.setDefaultItem();
      this.dialogChange(true);
    },
    dialogChange(value: boolean) {
      this.dialog = value;
    },
    getAll() {
      RegistroCarreraService.getRegistrosPendientesPago(this.$route.params.id)
        .then(response => {
          this.datos = response;
          this.loadTotalRecaudado();
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            icon: "error",
            title: "Registros Pagados",
            text: "No se pudo obtener"
          });
        });
    },
    downloadExport() {
      RegistroCarreraService.getRegistrosPagadosExcel(this.$route.params.id)
        .then(response => {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(new Blob([response.data]));
          const today = new Date();
          moment.locale("es");
          link.setAttribute(
            "download",
            `carrera-${this.$route.params.id}_${moment(today).format(
              "YYYY-MMMM-DD"
            )}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          console.log("no se pudo generar el documento");
        });
    }
  },
  mounted() {
    this.getAll();
  },
  watch: {
    dialog: function(newVal) {
      if (newVal === false) {
        this.setDefaultItem();
      }
    }
  }
});
